import { lazy } from '@loadable/component';
import { createFileRoute } from '@tanstack/react-router';
import { RouteName, TextKey } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';

const LazyBIHome = lazy(async () =>
    import(/* webpackChunkName: "businessIntelligence" */ '@mews-commander/business-intelligence/pages/BIHome').then(
        (module) => ({
            default: module.BIHome,
        })
    )
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/BusinessIntelligence/')({
    beforeLoad: ({ context: { checkPrivilege } }) => {
        checkPrivilege('viewSensitiveReports');
    },
    component: () => <LazyBIHome />,
    staticData: {
        owner: MewsTeam.Analytics,
        routeName: RouteName.BusinessIntelligenceIndex,
        title: TextKey.MewsBusinessIntelligence,
        type: RouteType.Frontend,
        excludeBreadcrumb: true,
    },
});
